import React, { useCallback } from "react";
import SearchFormCalendar from "./search_form_calendar";

const SearchFormCalendarErb = ({ baseUrl, extraParams, eventDate }) => {
  const eventDateFunc = useCallback(
    (dateStr) => {
      if (typeof window !== "undefined") {
        location.href = `${baseUrl}?event_date=${dateStr}${extraParams || ''}`;
      }
    },
    [baseUrl, extraParams]
  );

  const parsedDate = eventDate ? new Date(eventDate + "T00:00:00") : null;

  return (
    <div className="mb-4">
      <p className="text-center small mb-2" style={{ color: "#575757" }}>
        日付で探す
      </p>
      <SearchFormCalendar eventDate={parsedDate} eventDateFunc={eventDateFunc} />
    </div>
  );
};

export default SearchFormCalendarErb;
